// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { ThemeProvider } from './ThemeSwitcher';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );

// Error handling for production
window.addEventListener('error', (event) => {
    console.error('Global error:', event.error);
    // You can add error reporting service here
});

// Optional: Performance monitoring
if (process.env.NODE_ENV === 'development') {
    const reportWebVitals = (onPerfEntry) => {
        if (onPerfEntry && onPerfEntry instanceof Function) {
            import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
                getCLS(onPerfEntry);
                getFID(onPerfEntry);
                getFCP(onPerfEntry);
                getLCP(onPerfEntry);
                getTTFB(onPerfEntry);
            });
        }
    };
    
    reportWebVitals(console.log);
}